<template>
  <div class="col-12 col-md-12 col-lg-8">
    <div class="tit text-center">
      <p>Qual é o número da inscrição estadual da empresa?</p>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 col-xl-7">
        <form @submit="onSubmit">
          <div class="form-group text-left">
            <label for="valor-divida-bancaria" class="float-left">Número</label>
            <input type="text" class="form-control form-control-lg" v-focus v-mask="'integer'" v-model="NumeroInscricaoEstadual" placeholder="" required>
          </div>
          <div class="text-center fixedOptions">
            <button class="btn btn-lg btn-primary">Próximo <img src="../../assets/images/angle-right.svg"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    const NumeroInscricaoEstadual = this.solicitacao.Empresa.NumeroInscricaoEstadual
    return {
      NumeroInscricaoEstadual: NumeroInscricaoEstadual,
    }
  },
  props: {
    solicitacao: {required: true, type: Object}
  },
  methods: {
    onSubmit(e) {
      e.preventDefault()

      const newData = {
        Empresa: {
          NumeroInscricaoEstadual: this.NumeroInscricaoEstadual
        }
      }
      this.$emit('on-submit', newData)
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/DataInscricaoEstadualStep.vue